import { Box } from '@web/components/atoms/Layout'
import { Body2 } from '@web/components/atoms/Typography'

const TestModeBanner = () => (
  <Box
    data-testid="test-mode-banner"
    alignItems="center"
    display="flex"
    position="fixed"
    top={0}
    w="100vw"
    padding="0 12px"
    h="36px"
    bgColor="#e46602"
    color="ge.white"
    zIndex={9}
  >
    <Body2
      fontWeight={600}
      css={{
        '@media (max-width: 901px)': {
          fontSize: '12px',
        },
      }}
    >
      Test mode
    </Body2>
    <Body2
      margin="0 auto"
      css={{
        '@media (max-width: 901px)': {
          fontSize: '12px',
        },
      }}
    >
      You&rsquo;re using test data. Real money won&rsquo;t be used
    </Body2>
  </Box>
)

export default TestModeBanner
